import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/LoginPage";

/**
 * @name CaptureSoftTokensIdentityVerification
 * @returns {React.Component}
 * @description A capture component in the capture group "Soft Tokens - Logging In".
 */
export default function CaptureSoftTokensIdentityVerification(props) {
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "userID" ], "DemoUser")
    .update([ "password" ], "123456789012")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "modal", "id" ], "FirstTimeLoginModal")
        .update([ "modal", "data" ], { ui: { step: 2 } })
        .submit();

    return <LoginPage data={ data } ui={ ui } />
}